/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthHistoryAllergiesListAliases {
  BUTTON_ADD_HEALTH_HISTORY_ALLERGIES = 'button-add-health-history-allergies',
  CONTEXTUAL_BAR_HEALTH_HISTORY_ALLERGIES = 'contextual-bar-health-history-allergies',
  DECK_HEALTH_HISTORY_ALLERGIES = 'deck-health-history-allergies',
  FETCH_HEALTH_HISTORY_ALLERGIES = 'fetch-health-history-allergies',
  FILTERED_LIST_HEALTH_HISTORY_ALLERGIES = 'filtered-list-health-history-allergies',
  GLOBAL_ACTIONS_HEALTH_HISTORY_ALLERGIES = 'global-actions-health-history-allergies',
  HEALTH_HISTORY_CARD_ALLERGIES = 'health-history-card-allergies',
  LAYOUT_HEALTH_HISTORY_ALLERGIES_LIST = 'layout-health-history-allergies-list',
  LEGENDS_HEALTH_HISTORY_ALLERGIES = 'legends-health-history-allergies',
  PANEL_HEALTH_HISTORY_ALLERGIES = 'panel-health-history-allergies',
}
export { HealthHistoryAllergiesListAliases };
